"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = JobInfo;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JobInfo(_ref) {
  var moduleClass = _ref.moduleClass,
      left = _ref.left,
      right = _ref.right;

  return _react2.default.createElement(
    "div",
    {
      className: "type-job_info " + moduleClass
    },
    [left, right].map(function (_ref2, key) {
      var label = _ref2.label,
          value = _ref2.value;
      return _react2.default.createElement(
        "div",
        {
          className: "column",
          key: key
        },
        _react2.default.createElement(
          "label",
          null,
          label
        ),
        _react2.default.createElement(
          "p",
          null,
          ">",
          value
        )
      );
    })
  );
} /*
    {
      "type": "job_info",
      "left": {
        "label": "Average Salary",
        "value": "$85k"
      },
      "right": {
        "label": "Current Openings",
        "value": "120k"
      }
    }
  
    This is the job info component on the subsectors page.
  */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobInfo/JobInfo.jsx
// module id = 1182
// module chunks = 0